import Vue from "vue";
import Vuex from "vuex";
import filters from "./modules/filters";
import projects from "./modules/projects";
import sov_dashboard from "./modules/sov_dashboard";
import keywords from "./modules/keywords";
import usp from "./modules/usp";
import wordstat from "./modules/wordstat";
import ad_quality from "./modules/ad_quality";
import organic_sov_dashboard from "./modules/organic_sov_dashboard";
import keywords_organic from "./modules/keywords_organic";
import chart_utils from "../apps/common/chart-utils";
import user from "./modules/user";

// Yandex.Metrika counter
(function (m, e, t, r, i, k, a) {
  m[i] =
    m[i] ||
    function () {
      (m[i].a = m[i].a || []).push(arguments);
    };
  m[i].l = 1 * new Date();
  for (var j = 0; j < document.scripts.length; j++) {
    if (document.scripts[j].src === r) {
      return;
    }
  }
  (k = e.createElement(t)),
    (a = e.getElementsByTagName(t)[0]),
    (k.async = 1),
    (k.src = r),
    a.parentNode.insertBefore(k, a);
})(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
ym(91126829, "init", {
  clickmap: true,
  trackLinks: true,
  accurateTrackBounce: true,
  webvisor: true,
});

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    projects,
    filters,
    sov_dashboard,
    keywords,
    organic_sov_dashboard,
    keywords_organic,
    usp,
    wordstat,
    ad_quality,
    chart_utils,
    user,
  },
});
